const menuItems = [
    {
      title: "Home",
      url: "#home",
      cName: "nav-links"
    },
    {
      title: "Services",
      url: "#Services",
      cName: "nav-links"
    },
    {
      title: "Products",
      url: "#Products",
      cName: "nav-links"
    },
    {
      title: "Contact",
      url: "#Contact",
      cName: "nav-links"
    }
  ];

  export default menuItems;
